module.exports = __webpack_public_path__ + "static/img/logo_8.cb9959c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/logo_8.png
// module id = w/DJ
// module chunks = 1